import { DateTime } from 'luxon';

/**
 * Adjusts a DateTime to show as if it occurred recently for demo purposes
 * This is used in chart tooltips to display recent times even when the app date is frozen
 * @param {DateTime} dateTime - The original DateTime to adjust
 * @returns {DateTime} - The adjusted DateTime that appears recent
 */
export function adjustDateForDisplay(dateTime) {
  // If we're not in demo mode or no offset is available, return the original date
  if (!window.DEMO_FROZEN_TIME || !window.DEMO_TIME_OFFSET) {
    return dateTime;
  }

  // Add the time offset to make the date appear recent
  const adjustedMillis = dateTime.toMillis() + window.DEMO_TIME_OFFSET;
  return DateTime.fromMillis(adjustedMillis);
}

/**
 * Adjusts an ISO string date to show as if it occurred recently for demo purposes
 * @param {string} isoString - The original ISO string to adjust
 * @returns {DateTime} - The adjusted DateTime that appears recent
 */
export function adjustIsoDateForDisplay(isoString) {
  if (!isoString) {
    return null;
  }

  const originalDate = DateTime.fromISO(isoString);
  return adjustDateForDisplay(originalDate);
}
